module.exports = __webpack_public_path__ + "img/My-Photo__MYP0713_RM.8202cbd6.jpg";